export enum DxDiagnosisResultStatus {
  IN_PROGRESS = 1,
  COMPLETED = 2,
  DELETED = 3,
}